"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeChannelsService = void 0;
var tslib_1 = require("tslib");
var youtube_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/youtube/youtube");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var internal_error_1 = require("@wix/wix-vod-constants/dist/api-types/internal-error");
var to_error_1 = require("../../parsers/to-error");
var get_thumbnail_1 = tslib_1.__importDefault(require("./parsers/get-thumbnail"));
var channel_1 = require("./parsers/channel");
var YoutubeChannelsService = /** @class */ (function () {
    function YoutubeChannelsService(httpClient) {
        this.httpClient = httpClient;
        this.youtubeService = new youtube_1.YoutubeService(httpClient);
    }
    YoutubeChannelsService.prototype.getChannelsByIds = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.youtubeService
                        .getChannelsByIds(ids)
                        .then(function (response) {
                        return _.map(response.data.items, function (channel) {
                            return (0, channel_1.parseYoutubeChannel)(url_types_1.URL_TYPES.CHANNEL, channel);
                        });
                    })
                        .then(function (channels) { return _this.setMissingCovers(channels); })
                        .then(function (channels) {
                        var realIds = _.map(channels, 'externalId');
                        return tslib_1.__spreadArray(tslib_1.__spreadArray([], channels, true), _this.extendWithRemovedItems(ids, realIds, url_types_1.URL_TYPES.CHANNEL), true);
                    })
                        .then(function (channels) { return ({ data: channels }); })
                        .catch(to_error_1.toError)];
            });
        });
    };
    YoutubeChannelsService.prototype.getChannelsByUserName = function (userName) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.youtubeService
                        .getChannelsByUsername(userName)
                        .then(function (response) {
                        return _.map(response.data.items, function (channel) {
                            return (0, channel_1.parseYoutubeChannel)(url_types_1.URL_TYPES.CHANNEL, channel);
                        });
                    })
                        .then(function (channels) { return _this.setMissingCovers(channels); })
                        .then(function (channels) { return ({ data: channels }); })
                        .catch(to_error_1.toError)];
            });
        });
    };
    YoutubeChannelsService.prototype.getPlaylistsByIds = function (ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.youtubeService
                        .getPlayListsByIds(ids)
                        .then(function (response) {
                        return _.map(response.data.items, function (channel) {
                            return (0, channel_1.parseYoutubeChannel)(url_types_1.URL_TYPES.PLAYLIST, channel);
                        });
                    })
                        .then(function (playlists) {
                        var realIds = _.map(playlists, 'externalId');
                        return tslib_1.__spreadArray(tslib_1.__spreadArray([], playlists, true), _this.extendWithRemovedItems(ids, realIds, url_types_1.URL_TYPES.PLAYLIST), true);
                    })
                        .then(function (playlists) { return ({ data: playlists }); })
                        .catch(to_error_1.toError)];
            });
        });
    };
    YoutubeChannelsService.prototype.extendWithRemovedItems = function (originalIds, realIds, urlType) {
        var removedIds = _.difference(originalIds, realIds);
        return _.map(removedIds, function (id) {
            return (0, channel_1.parseYoutubeChannel)(urlType, {
                id: id,
                isExternalRemoved: true,
            });
        });
    };
    YoutubeChannelsService.prototype.getChannelsByUrl = function (url) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var type, id, result;
            return tslib_1.__generator(this, function (_a) {
                try {
                    result = this.youtubeService.parseChannelUrl(url);
                    type = result.type;
                    id = result.id;
                }
                catch (e) {
                    return [2 /*return*/, Promise.reject(new internal_error_1.InternalError(0, 'wpm_error.malformed_external_link'))];
                }
                switch (type) {
                    case url_types_1.URL_TYPES.PLAYLIST:
                        return [2 /*return*/, this.getPlaylistsByIds([id])];
                    case url_types_1.URL_TYPES.USER_NAME:
                        return [2 /*return*/, this.getChannelsByUserName(id)];
                    default:
                        return [2 /*return*/, this.getChannelsByIds([id])];
                }
                return [2 /*return*/];
            });
        });
    };
    // 1. get all youtube channels without cover
    // 2. fetch covers for from related playlists
    // 3. extend with covers
    // TODO: filter youtube channels only before applying this
    YoutubeChannelsService.prototype.setMissingCovers = function (channels) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var channelsWithoutCovers, playListIds, videoCovers;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        channelsWithoutCovers = _.reject(channels, 'coverUrl');
                        if (_.isEmpty(channelsWithoutCovers)) {
                            return [2 /*return*/, channels];
                        }
                        playListIds = _.map(channelsWithoutCovers, 'uploadsPlaylistId');
                        return [4 /*yield*/, this.getFallbackCovers(playListIds)];
                    case 1:
                        videoCovers = _a.sent();
                        _.forEach(channelsWithoutCovers, function (channel, index) {
                            channel.coverUrl = videoCovers[index] || null;
                        });
                        return [2 /*return*/, channels];
                }
            });
        });
    };
    YoutubeChannelsService.prototype.getCoverFromPlaylistItem = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.youtubeService
                        .getPlaylistItems({
                        urlType: url_types_1.URL_TYPES.PLAYLIST,
                        externalId: id,
                        itemsCount: 1,
                    })
                        .then(function (response) { return response.data.items[0]; })
                        .then(function (item) { return (item ? (0, get_thumbnail_1.default)(item.snippet.thumbnails) : null); })];
            });
        });
    };
    YoutubeChannelsService.prototype.getFallbackCovers = function (playlistIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requests;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                requests = _.map(playlistIds, function (id) {
                    return _this.getCoverFromPlaylistItem(id).catch(function () { return null; });
                });
                return [2 /*return*/, Promise.all(requests)];
            });
        });
    };
    return YoutubeChannelsService;
}());
exports.YoutubeChannelsService = YoutubeChannelsService;
//# sourceMappingURL=youtube-channels-service.js.map